export enum OAuthError {
  AccessDenied = 'access_denied',
}
